export default __webpack_public_path__ + "static/media/Parra-Nike-SB-Blazer-Low.b6998118.jpg";